import { dehydrate, QueryClient } from '@tanstack/react-query'
import type { UserGetUserBankAccountsInput } from '../api'
import userBankService from './user-bank.service'
import { EUserBankQueryKey } from './user-bank.types'

export const userBankGetOptions = (filter: UserGetUserBankAccountsInput) => {
  return {
    queryKey: [EUserBankQueryKey.GET, filter],
    queryFn: () => userBankService.get(filter),
  }
}

export const prefetchUserBanks = async (
  filter: UserGetUserBankAccountsInput,
) => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(userBankGetOptions(filter))
  return dehydrate(queryClient)
}
